import { render, staticRenderFns } from "./fbaOverseaWarehousingWorkspace.vue?vue&type=template&id=a8fdabfa&"
import script from "./fbaOverseaWarehousingWorkspace.vue?vue&type=script&lang=js&"
export * from "./fbaOverseaWarehousingWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./fbaOverseaWarehousingWorkspace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8fdabfa')) {
      api.createRecord('a8fdabfa', component.options)
    } else {
      api.reload('a8fdabfa', component.options)
    }
    module.hot.accept("./fbaOverseaWarehousingWorkspace.vue?vue&type=template&id=a8fdabfa&", function () {
      api.rerender('a8fdabfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/OverseaWarehousing/fbaOverseaWarehousingWorkspace.vue"
export default component.exports